import { Outlet } from 'react-router';
import { AppProviders } from '@/providers/AppProviders';

export function RootLayout() {
  // React Routerのレイアウトでは<html>タグを使用しない
  // index.htmlに既に<html>タグが存在するため、ここで使用するとhydration errorが発生する
  return (
    <AppProviders>
      <Outlet />
    </AppProviders>
  );
}
